import React, { useContext } from "react";
import { Routes, Route } from "react-router-dom";
import "./Report.css";
import SubHeader from "../Subheader/Subheader";
import NewReport from "./NewReport/NewReport";
import EditReport from "./EditReport/EditReport";
import EditReportSketchDesign from "./EditReportSketchDesign/EditReportSketchDesign";
import AllReports from "./AllReports/AllReports";
import DepartmentReports from "./AllReports/DepartmentReports/DepartmentReports";
import VacationManagement from "./VacationManagement/VacationManagement";
import DayoffDeletion from "./DayoffDeletion/DayoffDeletion";
import { UserContext } from "../../contexts/CurrentUserContext";
import PaymentsProgress from "../ProjectsV2/SketchDesignProjectFinance/PaymentsProgress/PaymentsProgress";

const SKETCH_DESIGN_DEPARTMENT_ID = 4;

function Report() {
  const { userData } = useContext(UserContext);

  const isSketchDesignDepartment = userData?.departments?.some(
    (d) => d.id === SKETCH_DESIGN_DEPARTMENT_ID
  );

  const hasAccessToReports = () => {
    const allowedAccessLevels = ["АДМС", "НО", "РО", "РГ", "ФИН", "ИК", "АДМП"];
    return (
      userData?.access_levels?.some((level) =>
        allowedAccessLevels.includes(level.name)
      ) ||
      userData?.id === 167 ||
      userData?.id === 229 ||
      userData?.id === 30 ||
      userData?.id === 63 || // HR менеджер
      userData?.id === 131 // Бухгалтер
    );
  };

  const hasAccessToVacations = () => {
    const allowedLevels = ["АДМС", "ИК"];
    return userData?.access_levels?.some((level) =>
      allowedLevels.includes(level.name)
    );
  };

  const hasAccessToDayoffDeletion = () => {
    return userData?.access_levels?.some((level) => level.name === "АДМС");
  };

  const hasAccessToPaymentsProgress = () => {
    return (
      userData?.access_levels?.some((level) =>
        ["АДМС", "ФИН"].includes(level.name)
      ) || [94, 96, 98, 99].includes(userData?.id)
    );
  };

  const tabs = isSketchDesignDepartment
    ? [
        { id: 1, label: "СОЗДАТЬ НОВЫЙ", path: "new", Component: NewReport },
        {
          id: 2,
          label: "РЕДАКТИРОВАТЬ",
          path: "edit",
          Component: EditReportSketchDesign,
        },
          ...(hasAccessToPaymentsProgress()
            ? [
                {
                  id: 3,
                  label: "ПРОГРЕСС ВЫПЛАТ",
                  path: "payments-progress",
                  Component: PaymentsProgress,
                },
              ]
            : []),
      ]
    : [
        { id: 1, label: "СОЗДАТЬ НОВЫЙ", path: "new", Component: NewReport },
        {
          id: 2,
          label: "РЕДАКТИРОВАТЬ",
          path: "edit",
          Component: EditReport,
        },
        { id: 3, label: "ТАБЕЛЬ", path: "all", Component: AllReports },
        ...(hasAccessToReports()
          ? [
              {
                id: 4,
                label: "ТАБЕЛЬ ОТДЕЛА",
                path: "department",
                Component: DepartmentReports,
              },
            ]
          : []),
        ...(hasAccessToVacations()
          ? [
              {
                id: 5,
                label: "КАДРОВЫЕ ОПЕРАЦИИ",
                path: "vacations-sick",
                Component: VacationManagement,
              },
            ]
          : []),
        ...(hasAccessToDayoffDeletion()
          ? [
              {
                id: 6,
                label: "УДАЛЕНИЕ ОТГУЛОВ",
                path: "dayoff-deletion",
                Component: DayoffDeletion,
              },
            ]
          : []),
        ...(hasAccessToPaymentsProgress()
          ? [
              {
                id: 7,
                label: "ПРОГРЕСС ВЫПЛАТ",
                path: "payments-progress",
                Component: PaymentsProgress,
              },
            ]
          : []),
      ];

  return (
    <div className="report">
      <SubHeader title="Отчеты" tabs={tabs} />
      <Routes>
        {tabs.map(({ path, Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}
      </Routes>
    </div>
  );
}

export default Report;
